import { useEffect, useState } from "react";

// Anchos que deciden la forma de la app (tramo 03 de huayruro-orden-y-mapa, reglas R-A y R-B).
//
// · UMBRAL_PANEL_PX — por debajo, las 5 pantallas del mostrador se pintan en el shell del celular
//   para quien vende o manda en la botica (R-A). Kevin eligió 1200 el 27-sep-2026 mirando capturas a
//   768, 1024, 1100, 1200 y 1440: con 1024, entre 1024 y 1199 px Caja caía en el panel, que mide
//   1200 px como mínimo (`Layout.tsx`, `min-w-[1200px]`), y había que desplazarse de costado. Se
//   revisa en el tramo 04, cuando el panel deje de tener ese ancho mínimo.
// · UMBRAL_FILA_PX — por debajo, la fila de destinos del mostrador pasa a 5 posiciones iguales con el
//   icono arriba y el nombre abajo, «← Panel» sube a la cabecera como «☰ Menú» (R-B) y las acciones
//   del Mostrador quedan en «Faltante · Cliente · Más» (R-D, elegida por Kevin el mismo día). Desde
//   768 px los 5 chips entran en una fila (necesitan 577 px el vendedor y 661 px encargado y dueño).
export const UMBRAL_PANEL_PX = 1200;
export const UMBRAL_FILA_PX = 768;

// ¿La ventana mide menos que `px` de ancho? Se recalcula al girar el equipo o cambiar el tamaño.
// `matchMedia` y no `innerWidth`: responde al mismo corte que las clases de Tailwind y no dispara un
// render por cada píxel del arrastre.
export function useMasAngostoQue(px: number): boolean {
  const consulta = `(max-width: ${px - 0.02}px)`;
  // Sin `matchMedia` (jsdom de las pruebas) se asume pantalla ancha: es el comportamiento de siempre.
  const hayMedia = typeof window !== "undefined" && typeof window.matchMedia === "function";
  const [angosto, setAngosto] = useState(() => (hayMedia ? window.matchMedia(consulta).matches : false));
  useEffect(() => {
    if (!hayMedia) return;
    const mq = window.matchMedia(consulta);
    const alCambiar = () => setAngosto(mq.matches);
    alCambiar();
    mq.addEventListener("change", alCambiar);
    return () => mq.removeEventListener("change", alCambiar);
  }, [consulta, hayMedia]);
  return angosto;
}
